import { useFeatureFlagWithPrefs } from '@fs/zion-flags'
import useFocusPerson from './useFocusPerson'

/**
 * Whether MyHeritage hints may be requested and shown for the focus person.
 *
 * Partner hints are gated on more than a flag: we do not send a living person, or one not visible
 * to all FamilySearch apps, to MyHeritage. Every caller has to apply the same gate, so it lives
 * here rather than being restated — the research help card and the hints-tab badge both read it.
 */
export default function useShowMyHeritageHints(): boolean {
  const { focusPerson } = useFocusPerson()
  const { data: flag, loading } = useFeatureFlagWithPrefs(
    'treeWeb_MyHeritageHints',
    {},
    {
      userPreferences: ['fslabs.labs'],
    }
  )

  return !loading && !!flag?.isOn && !focusPerson?.living && !!focusPerson?.visibleToAllWhenUsingFamilySearchApps
}
